import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import Home from "./components/Home";
import Map from "./components/Map";
import Record from "./components/Record";
import Notification from "./components/Notification";
import LoginPage from "./components/LoginPage";
import Meters from "./components/Meters";
import Panels from "./components/Panels";
import RubbishBins from "./components/RubbishBins";
import Panels2 from "./components/Panels2";
import Doors from "./components/Doors";
import WaterLeakage from "./components/WaterLeakage";
import BusBars from "./components/BusBars";
import SwitchBoardWL from "./components/SwitchBoardWL";
import PowerMeterPanels from "./components/PowerMeterPanels";
import FirePanels from "./components/FirePanels";
import TenantMeters from "./components/TenantMeters";
import RatDetect from "./components/RatDetect";
import FallsensorsSimple from "./components/Fallsensors_Simple"
import FallsensorsTest from "./components/FallsensorsTest"
import Environments from "./components/Environments"; 
import EfficiencyDashboard from "./components/EfficiencyDashboard";

import VibrationChart from "./components/VibrationChart";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
    },
    {
        path: '/map',
        element: <Map />
    },
    {
        path: '/doors',
        element: <Doors />
    },
    {
        path: '/leakage',
        element: <WaterLeakage />
    },
    {
        path: '/rubbishbins',
        element: <RubbishBins />
    },
    {
        path: '/notification',
        element: <Notification />
    },
    {
        path: '/meters',
        element: <Meters />
    },
    {
        path: '/panels',
        element: <Panels />
    },
    {
        path: '/loginpage',
        element: <LoginPage />
    },
    {
        path: '/firepanels',
        element: <FirePanels />
    },
    {
        path: '/panels2',
        element: <Panels2 />
    },
    {
        path: '/busbars',
        element: <BusBars />
    },    
    {
        path: '/switchwl',
        element: <SwitchBoardWL />
    },
    {
        path: '/tenantmeters',
        element: <TenantMeters />
    },    
    {
        path: '/ratdetect',
        element: <RatDetect />
    },
    {
        path: '/fallsensors',
        element: <FallsensorsSimple />
    },
    {
        path: '/fallsensorstest',
        element: <FallsensorsTest />
    },
    {
        path: '/environments',
        element: <Environments />
    },
    {
        path: '/vibration',
        element: <VibrationChart />
    },
    {
        path: '/powermeterpanels',
        element: <PowerMeterPanels />
    },
    {
        path: '/energy',
        element: <EfficiencyDashboard />
    },
];

export default AppRoutes;
